import { ReactNode } from "react"
import cx from "classnames"

export interface CaptionListItemProps {
  item: ReactNode
  className?: string
  size?: "xs" | "sm"
}

const CaptionListItem = ({
  item,
  className,
  size = "sm",
}: CaptionListItemProps) => (
  <li
    className={cx(
      "relative before:content-['•'] before:absolute before:-left-3",
      {
        "leading-[140%] !tracking-[0.36px] before:top-0 before:text-xs":
          size === "xs",
        "leading-[140%] tracking-[0.84px] before:top-[2px] before:text-sm":
          size === "sm",
      },
      className
    )}
  >
    {item}
  </li>
)

export default CaptionListItem
